import { render, staticRenderFns } from "./avatarBroker.vue?vue&type=template&id=4245a195"
import script from "./avatarBroker.vue?vue&type=script&lang=js"
export * from "./avatarBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports